import _classCallCheck from "/codebuild/output/src1787262798/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src1787262798/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DevExtreme (esm/core/events_strategy.js)
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import Callbacks from "./utils/callbacks";
import { each } from "./utils/iterator";
import { isFunction, isPlainObject } from "./utils/type";
export var EventsStrategy = /*#__PURE__*/function () {
  function EventsStrategy(owner) {
    _classCallCheck(this, EventsStrategy);

    var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    this._events = {};
    this._owner = owner;
    this._options = options;
  }

  _createClass(EventsStrategy, [{
    key: "hasEvent",
    value: function hasEvent(eventName) {
      var callbacks = this._events[eventName];
      return callbacks ? callbacks.has() : false;
    }
  }, {
    key: "fireEvent",
    value: function fireEvent(eventName, eventArgs) {
      var callbacks = this._events[eventName];

      if (callbacks) {
        callbacks.fireWith(this._owner, eventArgs);
      }

      return this._owner;
    }
  }, {
    key: "on",
    value: function on(eventName, eventHandler) {
      var _this = this;

      if (isPlainObject(eventName)) {
        each(eventName, function (e, h) {
          _this.on(e, h);
        });
      } else {
        var callbacks = this._events[eventName];

        if (!callbacks) {
          callbacks = Callbacks({
            syncStrategy: this._options.syncStrategy
          });
          this._events[eventName] = callbacks;
        }

        var addFn = callbacks.originalAdd || callbacks.add;
        addFn.call(callbacks, eventHandler);
      }
    }
  }, {
    key: "off",
    value: function off(eventName, eventHandler) {
      var callbacks = this._events[eventName];

      if (callbacks) {
        if (isFunction(eventHandler)) {
          callbacks.remove(eventHandler);
        } else {
          callbacks.empty();
        }
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      each(this._events, function (eventName, event) {
        event.empty();
      });
    }
  }], [{
    key: "create",
    value: function create(owner, strategy) {
      if (strategy) {
        return isFunction(strategy) ? strategy(owner) : strategy;
      } else {
        return new EventsStrategy(owner);
      }
    }
  }]);

  return EventsStrategy;
}();